import { BusinessResponses } from '@luxuryescapes/contract-business'
import request from 'api/requestUtils'

async function registerBusiness(businessData): Promise<BusinessResponses.BusinessCreate> {
  return request.post(
    '/api/business-traveller/businesses',
    businessData,
    { credentials: 'include' },
  )
}

export default registerBusiness
